var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclusiveContent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-jewelry-diamond-2--diamond-money-payment-finance-wealth"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 2.75H6.00002C5.70031 2.75823 5.40674 2.83687 5.14306 2.97957C4.87938 3.12227 4.65297 3.32502 4.48216 3.57143L1.23216 8.07143C0.990832 8.41245 0.870311 8.82431 0.889721 9.24163C0.909132 9.65896 1.06736 10.0578 1.3393 10.375L11.0893 21.6071C11.2562 21.8222 11.4701 21.9963 11.7146 22.116C11.9591 22.2358 12.2278 22.298 12.5 22.298C12.7723 22.298 13.0409 22.2358 13.2854 22.116C13.5299 21.9963 13.7438 21.8222 13.9107 21.6071L23.6607 10.375C23.9327 10.0578 24.0909 9.65896 24.1103 9.24163C24.1297 8.82431 24.0092 8.41245 23.7679 8.07143L20.5179 3.57143C20.3471 3.32502 20.1207 3.12227 19.857 2.97957C19.5933 2.83687 19.2997 2.75823 19 2.75V2.75Z",
    stroke: "#000001",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.5715 2.73212L7.21436 9.48212L12.5001 22.25",
    stroke: "#000001",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.4821 2.73212L17.8214 9.48212L12.5 22.25",
    stroke: "#000001",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.928589 9.48212H24.0714",
    stroke: "#000001",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusiveContent);
export default __webpack_public_path__ + "static/media/exclusiveContent.f3a9e8d8a8f46fc11028f432912c9a27.svg";
export { ForwardRef as ReactComponent };